import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-1784b988"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "sub-title" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "card-content" }
const _hoisted_8 = { class: "card-name" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "tips"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "card-descriptions"
}
const _hoisted_13 = ["innerHTML"]

import { IProgram } from '@/types/program';
  // import ApplyButton from './apply-button/index-view.vue';

  type TCard = {
    name: string;
    content: Array<{ text: string }>,
    tips: Array<{ text: string }>,
    descriptions?: Array<{ text: string }>,
  }

  interface IProps {
    title: string;
    subtitle: string;
    image: string;
    cards: Array<TCard>;
    program: IProgram;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    subtitle: null,
    image: null,
    cards: null,
    program: null
  },
  setup(__props: any) {

  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.subtitle), 1),
      _createElementVNode("img", {
        src: __props.image,
        class: "program-img"
      }, null, 8, _hoisted_6),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cards, (card, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", {
            class: _normalizeClass(["text-card", { isLast: index + 1 === __props.cards.length }])
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(card.name), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.content, (item, contentIndex) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: contentIndex,
                  innerHTML: item.text
                }, null, 8, _hoisted_9))
              }), 128))
            ]),
            (card.tips && card.tips.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.tips, (item, tipIndex) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: tipIndex,
                      innerHTML: item.text
                    }, null, 8, _hoisted_11))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 2),
          (card.descriptions && card.descriptions.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.descriptions, (item, descIndex) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: descIndex,
                    innerHTML: item.text
                  }, null, 8, _hoisted_13))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})